import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ProductsService from "@services/ProductsService";

export const viewProduct = createAsyncThunk(
  "product/view",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await ProductsService.viewProduct({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const archiveProduct = createAsyncThunk(
  "product/archive",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await ProductsService.archiveProduct({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const unArchiveProduct = createAsyncThunk(
  "product/restore",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await ProductsService.unArchiveProduct({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const deleteProduct = createAsyncThunk(
  "product/delete",
  async ({id, without}, {rejectWithValue}) => {
    try {
      const response = await ProductsService.deleteProduct({id, without});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const getAttachedScenarios = createAsyncThunk(
  "product/attached",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await ProductsService.getAttachedScenarios({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  current: null,
  attached_scenarios: [],
  errors: null,
  error: "",
  status: "",
};

const viewProductSlice = createSlice({
  name: "view-product",
  initialState,
  reducers: {
    setCurrent(state, action) {
      state.current = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearView() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(viewProduct.pending, (state) => {
        pendingState(state);
      })
      .addCase(viewProduct.fulfilled, (state, action) => {
        state.current = action.payload;
        fulfilledState(state);
      })
      .addCase(viewProduct.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(archiveProduct.pending, (state) => {
        pendingState(state);
      })
      .addCase(archiveProduct.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(archiveProduct.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(unArchiveProduct.pending, (state) => {
        pendingState(state);
      })
      .addCase(unArchiveProduct.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(unArchiveProduct.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(deleteProduct.pending, (state) => {
        pendingState(state);
      })
      .addCase(deleteProduct.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(deleteProduct.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(getAttachedScenarios.pending, (state) => {
        pendingState(state);
      })
      .addCase(getAttachedScenarios.fulfilled, (state, action) => {
        state.attached_scenarios = action.payload;
        fulfilledState(state);
      })
      .addCase(getAttachedScenarios.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {clearView, setCurrent, setError, setStatus} =
  viewProductSlice.actions;
export default viewProductSlice.reducer;
